// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first-div {
  margin-top: 25px;
}

.room-desc,
.room-name,
.bloc-button {
  margin-top: 25px;
}

img-cropper {
  text-align: center;
}

.parent-color {
  position: relative;
}
.parent-color #color {
  margin-top: 30px;
  -webkit-appearance: none;
  padding: 0;
  border: none;
  border-radius: 10px;
  width: 20px;
  height: 20px;
}
.parent-color #color::-webkit-color-swatch {
  border: none;
  border-radius: 10px;
  padding: 0;
}
.parent-color #color::-webkit-color-swatch-wrapper {
  border: none;
  border-radius: 10px;
  padding: 0;
}

.help-button {
  margin-left: -10px;
}

::ng-deep .form.full-width.ng-untouched.ng-pristine.ng-invalid {
  width: 840px !important;
  height: 400px !important;
  margin-top: 60px !important;
  margin-left: 50px !important;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}

::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--filled.mdc-text-field--no-label:hover {
  background-color: white !important;
}

::ng-deep .mat-mdc-form-field:hover .mat-mdc-text-field-wrapper,
::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-flex {
  background-color: white !important;
}

::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+rooms/add-room/add-room.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;;;EAGE,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAKA;EACE,kBAAA;AAFF;AAIE;EACE,gBAAA;EACA,wBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAIE;EACE,YAAA;EACA,mBAAA;EACA,UAAA;AAFJ;AAIE;EACE,YAAA;EACA,mBAAA;EACA,UAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;;AAKA;EACE,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;AAFF;;AAIA;EACE,kCAAA;AADF;;AAGA;EACE,kCAAA;AAAF;;AAEA;;EAEE,kCAAA;AACF;;AAEA;EAEE,kCAAA;AAAF","sourcesContent":[".first-div {\r\n  margin-top: 25px;\r\n}\r\n\r\n.room-desc,\r\n.room-name,\r\n.bloc-button {\r\n  margin-top: 25px;\r\n}\r\n\r\nimg-cropper {\r\n  text-align: center;\r\n}\r\n\r\n.select-color {\r\n}\r\n\r\n.parent-color {\r\n  position: relative;\r\n\r\n  #color {\r\n    margin-top: 30px;\r\n    -webkit-appearance: none;\r\n    padding: 0;\r\n    border: none;\r\n    border-radius: 10px;\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n  #color::-webkit-color-swatch {\r\n    border: none;\r\n    border-radius: 10px;\r\n    padding: 0;\r\n  }\r\n  #color::-webkit-color-swatch-wrapper {\r\n    border: none;\r\n    border-radius: 10px;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.help-button {\r\n  margin-left: -10px;\r\n}\r\n::ng-deep .form.full-width.ng-untouched.ng-pristine.ng-invalid {\r\n  width: 840px !important;\r\n  height: 400px !important;\r\n  margin-top: 60px !important;\r\n  margin-left: 50px !important;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--filled.mdc-text-field--no-label:hover {\r\n  background-color: white !important; \r\n}\r\n::ng-deep .mat-mdc-form-field:hover .mat-mdc-text-field-wrapper,\r\n::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-flex {\r\n  background-color: white !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-form-field:hover\r\n  .mat-mdc-form-field-focus-overlay {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
